__turbopack_context__.v({
  "addressHash": "AddressDetailPage-module__Bxnp1W__addressHash",
  "age": "AddressDetailPage-module__Bxnp1W__age",
  "badge": "AddressDetailPage-module__Bxnp1W__badge",
  "contractBadge": "AddressDetailPage-module__Bxnp1W__contractBadge",
  "copyButton": "AddressDetailPage-module__Bxnp1W__copyButton",
  "detailCard": "AddressDetailPage-module__Bxnp1W__detailCard",
  "emptyIcon": "AddressDetailPage-module__Bxnp1W__emptyIcon",
  "emptyState": "AddressDetailPage-module__Bxnp1W__emptyState",
  "header": "AddressDetailPage-module__Bxnp1W__header",
  "inBadge": "AddressDetailPage-module__Bxnp1W__inBadge",
  "inOut": "AddressDetailPage-module__Bxnp1W__inOut",
  "label": "AddressDetailPage-module__Bxnp1W__label",
  "link": "AddressDetailPage-module__Bxnp1W__link",
  "loading": "AddressDetailPage-module__Bxnp1W__loading",
  "method": "AddressDetailPage-module__Bxnp1W__method",
  "outBadge": "AddressDetailPage-module__Bxnp1W__outBadge",
  "pageButton": "AddressDetailPage-module__Bxnp1W__pageButton",
  "pageButtonActive": "AddressDetailPage-module__Bxnp1W__pageButtonActive",
  "pagination": "AddressDetailPage-module__Bxnp1W__pagination",
  "row": "AddressDetailPage-module__Bxnp1W__row",
  "skeleton": "AddressDetailPage-module__Bxnp1W__skeleton",
  "skeletonShimmer": "AddressDetailPage-module__Bxnp1W__skeletonShimmer",
  "statusSuccess": "AddressDetailPage-module__Bxnp1W__statusSuccess",
  "tab": "AddressDetailPage-module__Bxnp1W__tab",
  "tabActive": "AddressDetailPage-module__Bxnp1W__tabActive",
  "tabCount": "AddressDetailPage-module__Bxnp1W__tabCount",
  "table": "AddressDetailPage-module__Bxnp1W__table",
  "tableContainer": "AddressDetailPage-module__Bxnp1W__tableContainer",
  "tabs": "AddressDetailPage-module__Bxnp1W__tabs",
  "title": "AddressDetailPage-module__Bxnp1W__title",
  "typeBadge": "AddressDetailPage-module__Bxnp1W__typeBadge",
  "value": "AddressDetailPage-module__Bxnp1W__value",
});
